module.exports = "<div class=ibox-tools uib-dropdown> <a ng-click=showhide()> <i class=\"fa fa-chevron-up\"></i></a> <a ng-click=fullscreen()> <i class=\"fa fa-expand\"></i> </a> <a href uib-dropdown-toggle> <i class=\"fa fa-wrench\"></i> </a> <ul class=dropdown-user uib-dropdown-menu> <li><a href>Config option 1</a> </li> <li><a href>Config option 2</a> </li> </ul> <a ng-click=closebox()><i class=\"fa fa-times\"></i></a> </div>";


//////////////////
// WEBPACK FOOTER
// .-dna/app/views/common/ibox_tools_full_screen.html
// module id = 4189
// module chunks = 86